import React, { PropTypes } from 'react'
import { reduxForm, getFormValues } from 'redux-form'
import { connect } from 'react-redux'
import { get, size } from 'lodash'

import { Link } from 'core'
import { load, schemas } from 'api'
import { FormSection } from 'form'
import { formWizardFactory } from 'form-wizard'
import { withStripeElements } from 'stripe'
import { applyHOCs, selectSlug } from 'helpers'
import { Section } from 'layout'

import { submit } from './actions'
import steps from './steps'
import { FORM_NAME } from '../constants'
import { page, pageLoadSelectors } from 'page'

import css from './style.scss'

const LoginCTA = () => (
  <div className={css.link}>
    Already have an account? <Link to='/login' orange>Click here to login</Link>
  </div>
)

const FormWizard = formWizardFactory({
  steps,
  title: 'Register',
  getStepFormName: ({ props, step }) => {
    return `SUBACCOUNT JOIN - ${get(props, 'institution.slug')} - ${get(step, 'name')}`
  },
  completeAction: submit,
  // renders inside the form container, below the current step's continue button
  footer: () => (
    <FormSection>
      <LoginCTA />
    </FormSection>
  )
})

// Matches the max-width of the form container's content box (see
// form/FormContainer/style.scss) so this lines up with it exactly.
const CONTENT_WIDTH = 767

const SubaccountRegistrationPage = props => (
  <div>
    <Section>
      <div style={{ maxWidth: CONTENT_WIDTH, margin: '20px auto 0' }}>
        <LoginCTA />
      </div>
    </Section>
    <FormWizard {...props} />
  </div>
)

SubaccountRegistrationPage.propTypes = {
  institution: PropTypes.object.isRequired
}

const formValuesSelector = getFormValues(FORM_NAME)

export default applyHOCs([
  reduxForm({ form: FORM_NAME }),
  connect(state => {
    // form values may be initialized from localstorage.
    // in this case, don't set initial values
    if (size(formValuesSelector(state)) > 0) {
      return {}
    } else {
      return {
        initialValues: { newsletter_opt_in: true }
      }
    }
  }),
  withStripeElements(),
  page({
    layout: 'form',
    title: 'Register',
    ...pageLoadSelectors('institution')
  }),
  load({
    institution: {
      urlSelector: (state, props) => {
        return `/v2/institutions/slug/${props.slug}`
      },
      schema: schemas.institution
    }
  }),
  selectSlug({ paramName: 'institutionSlug' })
])(SubaccountRegistrationPage)
